module.exports = __webpack_public_path__ + "static/media/Feb11-S19.3a27d1de.png";